export default __webpack_public_path__ + "static/media/330_dummy2016-restaurant03-de.45941fff.png";